import { ChangeDetectionStrategy, Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollectionQuestionsStore } from 'src/app/features/collections/stors/collection-questions-store';
import { CollectionItemComponent } from '../collection-item/collection-item.component';
import { AnswersStore } from 'src/app/store/answers-store';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { MiniOperationsStore } from 'src/app/store/mini-operations-store';
import { DragStore } from 'src/app/store/drag-store';
import { Question } from 'src/app/models/question.model';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { combineLatest, filter, map, startWith, take, takeUntil } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { GlobalStore } from 'src/app/store/global-store';
import { EQuestionType } from 'src/app/models/questionType.model';
import { UuidService } from 'src/app/services/uuid.service';
import { GlobalService } from 'src/app/shared/services/global-service';

@Component({
    selector: 'que-collection-questions',
    imports: [CommonModule, CollectionItemComponent, FormsModule, ReactiveFormsModule, TranslateDirective, TranslatePipe],
    providers: [CollectionQuestionsStore, AnswersStore, QuestionnaireStore, MiniOperationsStore],
    templateUrl: './collection-questions.component.html',
    styleUrls: ['./collection-questions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectionQuestionsComponent {

  @Output() addQuestionEmit = new EventEmitter<Question>();

  filter = new FormControl<string>('');
  #globalStore = inject(GlobalStore);
  #globalService = inject(GlobalService);
  choosenQuestions: Question[] = []

  collection$ = combineLatest(this.#globalStore.collection$, this.filter.valueChanges.pipe(startWith(""))).pipe(
    map(([collection, inputValue]) => inputValue ? collection.filter(x => x.titleToData?.includes(inputValue)) : collection)
  )
  collectionSig$ = toSignal(this.collection$);
  isExist$ = toSignal(this.collection$.pipe(map(x => x.length > 0)));
  isExistWithoutFilter$ = toSignal(this.#globalStore.collection$.pipe(map(x => x.length > 0)));
  loading$ = toSignal(this.#globalStore.loadingCollection$);
  chooseQuestion(q: Question) {
    var newQuestion = this.#globalService.changeGuidsOfQuestions(q).question;
    var newsFollowQuestions = [...newQuestion.followQuestions?.map(x => { return { ...x, collectionQuestionId: x.id } as Question }) ?? []]
    this.addQuestionEmit.emit({ ...newQuestion, collectionQuestionId: newQuestion.id, followQuestions: newsFollowQuestions });
  }
  removeQuestion(que: Question) {
    this.choosenQuestions = this.choosenQuestions.filter(q => q.id != que.id);
  }
}

